import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import queryString from 'query-string';
import { getCamelCaseSlugFromFabricName, getNormalizedFabricQueryValue } from '../utils';
const useFabricPageUrlSync = history => {
  const $ = _c(10);
  let t0;
  if ($[0] !== history?.location?.search) {
    t0 = () => {
      const queryParams = queryString.parse(history?.location?.search);
      return Object.entries(queryParams).reduce(_temp, {});
    };
    $[0] = history?.location?.search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  history?.location?.search;
  const parseQueryParams = t0;
  let t1;
  if ($[2] !== history) {
    t1 = (selectedOptionName, t2, t3) => {
      const selectedOptionValue = t2 === undefined ? null : t2;
      const selectedOptionValueArray = t3 === undefined ? [] : t3;
      const currentQueryParams = queryString.parse(history?.location?.search);
      if (selectedOptionName === "fabric") {
        delete currentQueryParams.leather;
      } else {
        if (selectedOptionName === "leather") {
          delete currentQueryParams.fabric;
        }
      }
      const optionValue = selectedOptionValue ? getCamelCaseSlugFromFabricName(selectedOptionValue) : selectedOptionValueArray.length === 1 ? getCamelCaseSlugFromFabricName(selectedOptionValueArray[0]) : selectedOptionValueArray.length > 1 ? selectedOptionValueArray.map(_temp2).join(",") : "";
      const newQueryParam = queryString.stringify({
        ...currentQueryParams,
        [selectedOptionName]: optionValue || undefined
      });
      history.replace({
        search: newQueryParam ? `?${newQueryParam}` : ""
      });
    };
    $[2] = history;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateQueryParams = t1;
  let t2;
  if ($[4] !== history) {
    t2 = filterState => {
      const {
        selectedMaterialType,
        sortBy,
        selectedColors,
        selectedFeatures,
        selectedTiers,
        selectedFabric
      } = filterState;
      const queryParams_0 = queryString.parse(history?.location?.search);
      if (selectedMaterialType) {
        queryParams_0.material = getCamelCaseSlugFromFabricName(selectedMaterialType);
      }
      if (sortBy) {
        queryParams_0.sort = getCamelCaseSlugFromFabricName(sortBy);
      }
      const colorKeys = Object.keys(selectedColors || {}).filter(key_0 => selectedColors[key_0]);
      if (colorKeys.length > 0) {
        queryParams_0.color = colorKeys.map(_temp3).join(",");
      } else {
        delete queryParams_0.color;
      }
      const featureKeys = Object.keys(selectedFeatures || {}).filter(key_1 => selectedFeatures[key_1]);
      if (featureKeys.length > 0) {
        queryParams_0.feature = featureKeys.map(_temp4).join(",");
      } else {
        delete queryParams_0.feature;
      }
      if (selectedTiers && selectedTiers.length > 0) {
        queryParams_0.tier = selectedTiers.join(",");
      } else {
        delete queryParams_0.tier;
      }
      const materialKey = selectedMaterialType.toLowerCase();
      if (selectedFabric && selectedFabric.footerTitle && selectedFabric.footerTitle.name) {
        queryParams_0[materialKey] = getCamelCaseSlugFromFabricName(selectedFabric.footerTitle.name);
        if (materialKey === "fabric") {
          delete queryParams_0.leather;
        } else {
          if (materialKey === "leather") {
            delete queryParams_0.fabric;
          }
        }
      } else {
        delete queryParams_0.fabric;
        delete queryParams_0.leather;
      }
      const queryParamsString = queryString.stringify(queryParams_0);
      const newSearch = queryParamsString ? `?${queryParamsString}` : "";
      const currentSearch = history?.location?.search || "";
      if (newSearch !== currentSearch) {
        history.replace({
          search: newSearch
        }, {
          scroll: false
        });
      }
    };
    $[4] = history;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const syncStateToUrl = t2;
  let t3;
  if ($[6] !== parseQueryParams || $[7] !== syncStateToUrl || $[8] !== updateQueryParams) {
    t3 = {
      parseQueryParams,
      updateQueryParams,
      syncStateToUrl
    };
    $[6] = parseQueryParams;
    $[7] = syncStateToUrl;
    $[8] = updateQueryParams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default useFabricPageUrlSync;
function _temp(parsed, t0) {
  const [key, value] = t0;
  return {
    ...parsed,
    [key]: getNormalizedFabricQueryValue(key, value)
  };
}
function _temp2(activeKey) {
  return getCamelCaseSlugFromFabricName(activeKey);
}
function _temp3(color) {
  return getCamelCaseSlugFromFabricName(color);
}
function _temp4(feature) {
  return getCamelCaseSlugFromFabricName(feature);
}